// The top bar's pills redrawn once after they slide (owner 2026-10-27: "jak najeżdżam pierwszy raz na tekst, czcionka
// spada o jeden pixel"). The pills slide in by `top` (the tests read it) and each is a layer of its own (the glass
// blur); Chrome draws the text while the pill is between pixels and then only moves that drawing into place, so the
// words stood 1 px high until a hover drew them again. After the slide a colour one step off for two frames makes it
// draw the words again where they are (nobody can see one step of colour). A background change does not.
const PILLS = '#menu_button, #game_status, #game_labels';
const TEXT = '#menu_button, #game_status a, #game_labels';

export function installPillRedraw(): void {
  document.addEventListener('transitionend', (e) => {
    if (e.propertyName !== 'top' || !(e.target instanceof HTMLElement) || !e.target.matches(PILLS)) return;
    const els = [e.target, ...e.target.querySelectorAll<HTMLElement>('a')].filter((el) => el.matches(TEXT));
    for (const el of els) el.style.setProperty('color', 'rgb(237 228 217)');
    requestAnimationFrame(() => requestAnimationFrame(() => {
      for (const el of els) el.style.removeProperty('color');
    }));
  });
}
